import React, { useState, useEffect } from "react";
import BaseMasterGrid from "../BaseMasterGrid";
import ServiceSlider from "./ServiceSlider";
import axios from "axios";
import { BASE_URL } from "../../../constants";
import KendoLoader from "../../KendoLoader";

const ServiceMaster = () => {
  const defaultEntity = {
    code: "",
    name: "",
    category: "",
    description: "",
    isActive: true,
  };
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [entities, setEntities] = useState([]);
  const [service, setService] = useState(defaultEntity);
  const [pageState, setPageState] = useState({
    take: 10,
    skip: 0,
    total: 0,
    logic: "and",
    filters: [
      {
        field: "name",
        operator: "contains",
        value: "",
      },
    ],
  });

  const gridColumns = [
    { field: "id", title: "ID", hidden: true },
    { field: "code", title: "Code", width: "100" },
    {
      field: "name",
      title: "Name",
      filterable: true,
      sortable: true,
      hidden: false,
    },
    {
      field: "description",
      title: "Description",
      filterable: true,
      sortable: true,
    },
    {
      field: "isActive",
      title: "Status",
      isBoolean: true,
      // filterable: true,
      // sortable: true,
    },
  ];

  const loadData = async (searchText, state) => {
    setLoading(true);
    const pageSize = state.take;
    const pageNumber = Math.floor(state.skip / state.take) + 1;
    const res = await axios.get(
      `${BASE_URL}/LogisticsService?searchText=${searchText}&page=${pageNumber}&pageSize=${pageSize}`
    );
    setEntities(res.data.data);
    setPageState((pre) => ({
      ...pre,
      total: res.data.totalCount,
      skip: (res.data.pageNo - 1) * res.data.pageSize,
      take: res.data.pageSize,
      value: searchText,
    }));
    setLoading(false);
  };
  const onUpdate = (item) => {
    setEntities(entities.map((c) => (c.id === item.id ? { ...item } : c)));
  };

  const onGridFilter = (e) => {
    let searchText = "";
    if (e.filter && e.filter.filters && e.filter.filters[0].value !== "") {
      searchText = e.filter.filters[0].value;
    } else {
      searchText = "~ALL";
    }
    const state = {
      ...pageState,
      filter: { ...e.filter },
      skip: 0,
      value: searchText,
    };
    setPageState(state);
    loadData(searchText, state);
  };

  const onCreate = (item, id) => {
    setEntities([...entities, { ...item, id: id }]);
  };
  const onCreateClick = () => {
    setService(defaultEntity);
    setOpen(true);
  };
  const onEditClick = (e) => {
    setService({
      ...e.dataItem,
      country: { code: e.dataItem.countryCode, name: e.dataItem.countryName },
    });
    setOpen(true);
  };

  useEffect(() => {
    const searchText = "~ALL";
    loadData(searchText, pageState);
  }, []);

  return (
    <div className="px-4 py-4 sm:px-6 lg:px-8">
      <div className="pb-5 border-b border-gray-200 sm:flex sm:items-center sm:justify-between">
        <h3 className="text-lg leading-6 font-medium text-gray-900">Charge</h3>
        <div className="mt-3 flex sm:mt-0 sm:ml-4">
          <button
            type="button"
            className="ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            onClick={onCreateClick}
          >
            Create
          </button>
        </div>
      </div>
      <div className="flex flex-col">
        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div className="shadow relative overflow-hidden sm:rounded-lg">
              {loading && <KendoLoader />}
              <BaseMasterGrid
                data={entities}
                columns={gridColumns}
                onEditClick={onEditClick}
                setPageState={setPageState}
                loadData={loadData}
                pageState={pageState}
                onGridFilter={onGridFilter}
              ></BaseMasterGrid>
            </div>
          </div>
        </div>
      </div>
      <ServiceSlider
        open={open}
        setOpen={setOpen}
        service={service}
        setService={setService}
        onUpdate={onUpdate}
        onCreate={onCreate}
      />
    </div>
  );
};

export default ServiceMaster;
